module.exports = __webpack_public_path__ + "public/images/gaming.08e330bf4d4a8684b927d32e0e9786f9.png";